export default __webpack_public_path__ + "ui/assets/img/arrow-left-disabled-32.svg";